import React from 'react'
import { Button, Col, Row, Radio, Spin  } from 'antd'
import { connect } from 'react-redux'

import { onLoadSetting, onSaveSetting } from './../../../../../actions/settingMerchantAction';
import lang from './../../../../../languages/en'
import { alertSuccess } from './../../../../../services/dialog'
import { setHeight } from './../../../../../services/helper';
import handlePermission from '../../../../app/handlePermission';
import { permissions } from '../../../../../constants';

const RadioGroup = Radio.Group

const MASTER_UPDATE_SETTING_KEY = {
    ASK_ME: 1,
    WITHOUT_ASK_ME: 2,
    NEVER_UPDATE: 3
}

const MASTER_UPDATE_SETTING_VALUES = [
    {
        key: MASTER_UPDATE_SETTING_KEY.ASK_ME,
        value: lang.master_update_setting_ask_me
    },
    {
        key: MASTER_UPDATE_SETTING_KEY.WITHOUT_ASK_ME,
        value: lang.master_update_setting_without_ask
    },
    {
        key: MASTER_UPDATE_SETTING_KEY.NEVER_UPDATE,
        value: lang.master_update_setting_never_update
    }
]

class MasterUpdateSetting extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            itemNameSettingCurrent: null
        }

        
        this.setHeightBodyContent();
    }

    componentDidMount() {
        var that = this;
        that.setHeightBodyContent();
        window.addEventListener('resize', () => {
            that.setHeightBodyContent();
        });
        document.getElementById('setting-merchant').className += " update-setup";
    }

    componentWillUnmount() {
        document.getElementById('setting-merchant').classList.remove("update-setup");
    }

    componentDidUpdate(prevProps) {
        this.setHeightBodyContent();

        const _this = this
        if (prevProps.isEditing  && !this.props.isEditing) {
            if(!this.props.editError) {
                alertSuccess(
                    lang.item_master_update_success,
                    MASTER_UPDATE_SETTING_VALUES.find(item => item.key === _this.state.itemNameSettingCurrent).value,
                    () => {
                        _this.props.goBack()
                    }
                )
            }
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.itemNameSettingCurrent !== state.itemNameSettingCurrent && state.itemNameSettingCurrent === null) {
          return {
            itemNameSettingCurrent: props.itemNameSettingCurrent
          };
        }

        return null;
    }

    setHeightBodyContent() {
        setTimeout(() => {
            setHeight()
        }, 200);
    }

    onSelectUpdateSetting = (e) => {
        this.setState({
            itemNameSettingCurrent: e.target.value,
        })
    }

    onCancelSetting = () => {
        this.props.goBack()
    }

    onSaveSetting = () => {
        const { itemNameSettingCurrent } = this.state

        this.props.onSaveSetting(itemNameSettingCurrent)
    }

    render() {
        return (
            <Spin spinning={this.props.isLoading} tip='Loading...'>
                <div id="setting-content" className='master-update-setting'>
                    <div id="settings-select">
                        <Row>
                            <Col span={5} />
                            <Col span={10} className="settings-select-content">
                                <div id="settings-select-desc">
                                    <span>{lang.master_update_setting_desc}</span>
                                </div>
                                <RadioGroup
                                    className="radio-group"
                                    onChange={this.onSelectUpdateSetting}
                                    value={this.state.itemNameSettingCurrent}
                                >
                                    {
                                        MASTER_UPDATE_SETTING_VALUES.map(item => (
                                            <Radio
                                                disabled={!handlePermission(permissions.ItemNameUpdateItemNameSetting)}
                                                key={item.key}
                                                className="radio-btn"
                                                value={item.key}
                                            >
                                                {item.value}
                                            </Radio>
                                        ))
                                    }
                                </RadioGroup>
                            </Col>
                        </Row>
                        <Row className="footer-component">
                        {
                            handlePermission(permissions.ItemNameUpdateItemNameSetting) ? 
                            
                                <div className="fix-footer">
                                    <Button
                                        className="cancel"
                                        onClick={this.onCancelSetting}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        className="save ant-btn-primary"
                                        onClick={this.onSaveSetting}
                                    >
                                        Save
                                    </Button>
                                </div>
                            
                            : ""

                        }
                        </Row>
                    </div>
                </div>
            </Spin>
        )
    }
}

const mapStateToProps = state => {
    return {
        isLoading: state.settingMerchantReducer.loading_save,
        itemNameSettingCurrent: state.settingMerchantReducer.itemNameSettingCurrent,
        isEditing: state.settingMerchantReducer.isEditing,
        editError: state.settingMerchantReducer.editError,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLoadSetting: payload => {
            dispatch(onLoadSetting(payload))
        },
        onSaveSetting: payload => {
            dispatch(onSaveSetting(payload))
        }
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MasterUpdateSetting)


// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/master-update-setting/index.js